// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3Zd2w","loaderOuter":"PageOverlayLoader_loaderOuter__2hEcQ"};